import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { Index2Component } from './index2/index2.component';


const routes: Routes = [
    {
        path: '',
        redirectTo: '',
        pathMatch: 'full'
    },
    {
        path: '',
        component: Index2Component
    },
    {
        path: '**',
        redirectTo: '',
        pathMatch: 'full'
    },

];

@NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule]
})
export class PagesRoutingModule { }
